import React from 'react'
import dayjs from 'dayjs'
import { CarouselAPI } from '../../../../constructs/carousel/interface'
import { useAPIContext } from '../../context/api'

export const useFetchCarouselData = ({ widgetId }: { widgetId: string }) => {
  const { callEndpoint } = useAPIContext()
  const [loading, setLoading] = React.useState(false)

  const fetchCarouselData = React.useCallback(
    async (selectedDate: dayjs.Dayjs) => {
      setLoading(true)
      try {
        const carousel = await callEndpoint<CarouselAPI, 'get'>(
          'carousel',
          `/${widgetId}/${selectedDate.format('YYYY-MM-DD')}`,
          'GET',
        )

        return carousel.content || []
      } catch (err) {
        console.error('Error al obtener el carousel', err)
        return []
      } finally {
        setLoading(false)
      }
    },
    [widgetId, callEndpoint],
  )

  return { fetchCarouselData, loading }
}
